<template>
  <article class="storefinderResult">
    <header class="storefinderResult__header">
      <div class="storefinderResult__company interactive" @click="onCompanyClick">
        {{ store.company }}
        <IconStar class="storefinderResult__premiumIcon" v-if="store.isPremium"/>
      </div>
    </header>
    <div class="storefinderResult__distance">{{ Number((store.distance).toFixed(1)) }}&nbsp;km</div>

    <p class="storefinderResult__address">
      <span v-if="store.address">{{ store.address }}
        <br>
      </span>
      <span v-if="store.zip">{{ store.zip }}</span>
      <span v-if="store.city">{{ store.city }}
        <br>
      </span>
      <span v-if="store.phone">
        {{ staticTextPhone }}:
        <a :href="store.phone | tel">{{ store.phone }}</a>
        <br>
      </span>
      <span v-if="store.www">
        {{ staticTextWeb }}:
        <a :href="store.www | http" target="_blank">{{ store.www }}</a>
        <br>
      </span>
      <span v-if="store.email">
        {{ staticTextEmail }}:
        <a :href="store.email | mailto" target="_blank">{{ store.email }}</a>
        <br>
      </span>
    </p>

    <div class="storefinderResult__categoryListWrapper">
      <ul class="storefinderResult__categoryList">
        <li v-for="tag in store.tags" class="storefinderResult__categoryListItem" :data-category="tag.uid">
          <template v-if="tag.image">
            <img class="storefinderResult__categoryIcon" :src="tag.image" :alt="tag.tagTitle" :title="tag.tagTitle">
          </template>
          <template v-else>
            <div class="storefinderResult__categoryIcon storefinderResult__categoryIcon--placeholder" :title="tag.tagTitle"></div>
          </template>
        </li>
      </ul>
    </div>

    <div class="storefinderResult__actions">
      <a class="button storefinder__button storefinder__button--result" :href="store | directions" target="_blank">{{ staticTextDirections }}</a>
      <button class="storefinder__button storefinder__button--result" type="button" v-if="store.email" @click="$emit('contact', store)">{{ staticTextContactButton }}</button>
    </div>
  </article>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';
  export default {
    name: 'storefinder-result',
    props: {
      store: {
        type: Object,
        required: true,
        default: {
          company: '',
          address: '',
          zip: '',
          city: '',
          phone: '',
          www: '',
          distance: -1.0,
          image: '',
          isPremium: false,
        },
      },
      staticTextPhone: {
        type: String,
        default: '',
      },
      staticTextWeb: {
        type: String,
        default: '',
      },
      staticTextEmail: {
        type: String,
        default: '',
      },
      staticTextDirections: {
        type: String,
        default: '',
      },
      staticTextContactButton: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters(["stores"]),
    },
    filters: {
      tel(phoneNumber) {
        return 'tel:' + phoneNumber.replace(/\s+/g, '');
      },
      mailto(email) {
        return 'mailto:' + email;
      },
      http(url) {
        return url.startsWith('http') ? url : `http://${url}`;
      },
      directions(store) {
        return 'https://maps.google.com/?daddr=' + store.address.trim() + ' ' + store.zip.trim() + ' ' + store.city.trim();
      },
    },
    methods: {
      ...mapMutations(["updateStore"]),
      tagItemStyle(tag) {
        if (this.$store.getters.selectedTags.includes(tag.uid)) {
          return {
            background: '#ffdc00',
            borderRadius: '4px',
            fontSize: '14px',
            margin: '2px 0',
          };
        }

        return {
          fontSize: '14px',
        };
      },
      onCompanyClick() {
        this.store.selected = !this.store.selected
      },
    },
  };
</script>
